import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import {
  BarChart as BarChartIcon,
  PieChart as PieChartIcon,
  TimelineOutlined as TimelineIcon,
} from "@mui/icons-material";

/**
 * Component for selecting chart visualization type
 * @param {Object} props - Component props
 * @param {string} props.chartType - Current chart type
 * @param {Function} props.onChartTypeChange - Chart type change handler
 * @returns {JSX.Element} Chart type selector component
 */
const ChartTypeSelector = ({ chartType, onChartTypeChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "background.paper",
        borderRadius: 1,
        border: 1,
        borderColor: "divider",
      }}
    >
      <Tooltip title="Barras">
        <IconButton
          color={chartType === "bar" ? "primary" : "default"}
          onClick={() => onChartTypeChange("bar")}
          size="small"
        >
          <BarChartIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Linhas">
        <IconButton
          color={chartType === "line" ? "primary" : "default"}
          onClick={() => onChartTypeChange("line")}
          size="small"
        >
          <TimelineIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Pizza">
        <IconButton
          color={chartType === "pie" ? "primary" : "default"}
          onClick={() => onChartTypeChange("pie")}
          size="small"
        >
          <PieChartIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default ChartTypeSelector;
